"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morolo": {
    "62ad5940": [{
      "hkey": "dd25c6df",
      "slug": "cerquotti-madonna-del-piano",
      "name": "Cerquotti-Madonna del Piano",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-piano": [{
      "hkey": "dd25c6df",
      "slug": "cerquotti-madonna-del-piano",
      "name": "Cerquotti-Madonna del Piano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;